import React from "react";
import AppModal from "../../../modals/app-modal";
import { Grid } from "@material-ui/core";

import ReportedUserDetailsView from "./components/reported-user-deatils-view";
import ReportDetailedView from "./components/report-detailed-view";
import { ReportModalContext } from "./context";

const ReportViewModal = ({ showModal, closeModal, report = {}, postId }) => {
  return (
    <AppModal
      visibility={showModal}
      title="Review Report"
      showActionButtons={false}
      handleClose={closeModal}
    >
      <ReportModalContext.Provider
        value={{ showModal, closeModal, report, postId }}
      >
        <Grid
          container
          direction="column"
          className="report-detail-view-modal gap-y-16 pb-16"
        >
          <ReportedUserDetailsView />
          <ReportDetailedView />
        </Grid>
      </ReportModalContext.Provider>
    </AppModal>
  );
};

export default ReportViewModal;
